// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/widgets/browserWidget.styl
// module id = 405
// module chunks = 0